;(function () {
  $(document).on("turbolinks:load turbo:load", function () {
    const promoTypeSelectBtn = $(".js-promo-btn-type-wrapper").find("select")
    if (!promoTypeSelectBtn.length) return
    if (!promoTypeSelectBtn.hasClass("select2-hidden-accessible"))
      promoTypeSelectBtn.select2()

    const promoLinkInputWrapper = $(".js-promo-custom-link-wrapper")
    const promoProductSelectWrapper = $(".js-promo-product-wrapper")
    const promoVariantSelectWrapper = $(".js-promo-variant-wrapper")
    const promoBtnTextInputWrapper = $(".js-promo-btn-text-wrapper")

    const promoPlacementSelect = $(".js-promo-placement")
    const promoStyleSelect = $(".js-promo-style")

    const promoLinkInput = promoLinkInputWrapper.find("input")
    const promoProductSelect = promoProductSelectWrapper.find("select")
    const promoVariantSelect = promoVariantSelectWrapper.find("select")
    const promoBtnTextInput = promoBtnTextInputWrapper.find("input")

    let cachedBtnText = promoBtnTextInput.val() || ""

    function resetVariantSelect() {
      promoVariantSelect.prop("required", false).prop("disabled", true)
      promoVariantSelect
        .empty()
        .append('<option value=""></option>')
        .trigger("change.select2")
    }

    if (
      promoProductSelect.length &&
      !promoProductSelect.hasClass("select2-hidden-accessible")
    ) {
      const url = promoProductSelect.data("url")
      promoProductSelect.select2({
        ajax: {
          url: `${url}.json`,
          dataType: "json",
          delay: 200,
          data: (params) => ({ q: params.term }),
          processResults: (data) => ({
            results: (Array.isArray(data) ? data : data.items || []).map(
              (i) => ({
                id: i.id,
                text: i.text || i.title,
              })
            ),
          }),
        },
        placeholder: "Select a product",
        width: "100%",
      })

      const id = promoProductSelect.data("selected")
      const text = promoProductSelect.data("preload_text")
      if (id && text) {
        const opt = new Option(text, id, true, true)
        promoProductSelect.append(opt).trigger("change")
      }
    }

    function updatePromoFieldVisibility() {
      const btnType = promoTypeSelectBtn.val()

      promoLinkInputWrapper.addClass("d-none")
      promoProductSelectWrapper.addClass("d-none")
      promoVariantSelectWrapper.addClass("d-none")

      promoLinkInput.prop("required", false)
      promoProductSelect.prop("required", false).prop("disabled", false)
      resetVariantSelect()

      promoBtnTextInput.prop("required", false).prop("disabled", true)
      promoBtnTextInputWrapper.removeClass("d-none")

      if (btnType === "custom_link") {
        promoLinkInputWrapper.removeClass("d-none")
        promoLinkInput.prop("required", true)
      } else if (btnType === "view_product" || btnType === "add_to_cart") {
        promoProductSelectWrapper.removeClass("d-none")
        promoVariantSelectWrapper.removeClass("d-none")
        promoProductSelect.prop("required", true)
        promoProductSelect.trigger("change")
        if (btnType === "view_product") resetVariantSelect()
      }

      ;[
        promoProductSelect,
        promoVariantSelect,
        promoPlacementSelect,
        promoStyleSelect,
      ].forEach(function (el) {
        if (!el.hasClass("select2-hidden-accessible")) el.select2()
      })

      if (["custom_link", "view_product", "add_to_cart"].includes(btnType)) {
        promoBtnTextInput.prop("required", true).prop("disabled", false)
        if (!promoBtnTextInput.val().trim()) {
          promoBtnTextInput.val(cachedBtnText || "Claim Offer")
        }
      } else {
        cachedBtnText = promoBtnTextInput.val()
        promoBtnTextInput.val("").prop("required", false).prop("disabled", true)
      }
    }

    promoTypeSelectBtn.on("change", updatePromoFieldVisibility)
    updatePromoFieldVisibility()

    promoProductSelect.off("change").on("change", function () {
      const productId = $(this).val()
      const btnType = promoTypeSelectBtn.val()
      const shouldEnable = btnType === "add_to_cart"
      const selectedVariantId = shouldEnable
        ? promoVariantSelect.data("selected")
        : null

      if (!productId || btnType === "view_product") {
        resetVariantSelect()
        return
      }

      $.ajax({
        url: `/api/v1/product_variants?product=${encodeURIComponent(productId)}`,
        type: "GET",
        dataType: "json",
        global: false,
        success: function (variants) {
          promoVariantSelect
            .empty()
            .append('<option value=""></option>')
            .trigger("change.select2")

          if (!variants || !variants.length) {
            promoVariantSelect.prop("disabled", true).prop("required", false)
            return
          }

          variants.forEach((v) => {
            const opt = new Option(
              v.title,
              v.id,
              false,
              String(v.id) === String(selectedVariantId)
            )
            promoVariantSelect.append(opt)
          })

          promoVariantSelect
            .prop("disabled", !shouldEnable)
            .prop("required", shouldEnable)
            .trigger("change.select2")
        },
        error: function () {
          resetVariantSelect()
        },
      })
    })

    if (
      promoTypeSelectBtn.val() === "add_to_cart" &&
      promoProductSelect.val()
    ) {
      promoProductSelect.trigger("change")
    }
  })
})()
